import bugReportApi from '@/api/bugReport.api'

import { makeAdapter } from './Adapter'
import type Controller from './Controller'

class BugReportController implements Controller {
  adapter = makeAdapter({
    from() {
      return
    },
    to() {
      return
    },
  })

  postErrorReportConcept = async (data: req.BugReportData) => {
    await bugReportApi.postErrorReportConcept(data)
  }

  postErrorReportLittleChapter = async (data: req.BugReportData) => {
    await bugReportApi.postErrorReportLittleChapter(data)
  }

  postErrorReportPublicProblem = async (data: req.BugReportData) => {
    await bugReportApi.postErrorReportPublicProblem(data)
  }

  postErrorReportCustomProblem = async (data: req.BugReportData) => {
    await bugReportApi.postErrorReportCustomProblem(data)
  }

  postErrorReportArithmetic = async (data: req.BugReportData) => {
    await bugReportApi.postErrorReportWorksheet(data)
  }
}

export const bugReportController = new BugReportController()
